const initialState = {
  list: [],
  total: "",
  searchKey: "",
};

const ManageGoalsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case "MANAGE_ALL_GOALS_RESPONSE":
      return {
        ...state,
        list: [...action.data.list],
        total: action.data.total,
      };

    default:
      return state;
  }
};

export default ManageGoalsListReducer;
